import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from './ui/sidebar';

import { Project } from '@/state/use-admin';
import { Check, ChevronsUpDown, Swords } from 'lucide-react';
import { useState } from 'react';

interface Game {
	name: string;
	id: number;
}

const GameSwitcher = ({
	project,
	selectedGameId,
	onSelectGame,
}: {
	project: Project;
	selectedGameId: number;
	onSelectGame: (gameId: number) => void;
}) => {
	const [selectGame, setSelectGame] = useState<Game | undefined>(
		project?.games?.find(game => game.id === selectedGameId)
	);

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<SidebarMenuButton
							size="lg"
							className="data-[stage=open]:bg-sidebar-accent data-[stage=open]:text-sidebar-accent-foreground"
						>
							<div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
								<Swords className="size-4" />
							</div>
							<div className="flex flex-col gap-1 leading-none">
								<span className="font-semibold">
									{project.name}
								</span>
								<span className="">
									{selectGame?.name ?? 'Select a game'}
								</span>
							</div>
							<ChevronsUpDown className="ml-auto" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						className="w-[--radix-dropdown-menu-trigger-width]"
						align="start"
					>
						{project.games.map(game => (
							<DropdownMenuItem
								key={game.id}
								onSelect={() => {
									setSelectGame(game);
									onSelectGame(game.id);
								}}
							>
								{game.name}{' '}
								{selectGame?.id === game.id && (
									<Check className="ml-auto" />
								)}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	);
};

export default GameSwitcher;
